import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';

/**
 * Mirrors the backend access rule for the data request seen-flag endpoints
 * (form / questions / table-view seenFlag): "seen" state belongs to the
 * seller side (project owner and affiliated members) and to VetValue admins,
 * who have their own seen-by-admin tracking. Every other engagement party
 * (buyer, advisor/broker, observer) is a read-only viewer there — the API
 * rejects their seen-flag writes, so the client must not send them.
 */
export const canMarkDataRequestItemsAsSeen = (
    party: TimelineParty
): boolean =>
    party === TimelineParty.Seller ||
    party === TimelineParty.SellerAndBuyer ||
    party === TimelineParty.VetValue;
